module.exports = __webpack_public_path__ + "static/img/referral-icon.f7b6560.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/referral-icon.png
// module id = oP5v
// module chunks = 0 2 20